import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem 1rem 1rem;
  gap: 1rem;
`;
